import { render, staticRenderFns } from "./title-material.vue?vue&type=template&id=556dccb8&scoped=true"
import script from "./title-material.vue?vue&type=script&lang=js"
export * from "./title-material.vue?vue&type=script&lang=js"
import style0 from "./title-material.vue?vue&type=style&index=0&id=556dccb8&prod&scoped=true&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556dccb8",
  null
  
)

export default component.exports